import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/BlogComponents/BlogComponent.tsx");
